// View boundaries: what the API sends is read through these, so a missing or
// malformed list shows as empty instead of taking the whole screen down.
export const list = <T,>(v: T[] | null | undefined): T[] => (Array.isArray(v) ? v : []);

import type { BoardView, StatsView, WeekView } from "./types";

const obj = <T extends object,>(v: T | null | undefined, fallback: T): T => (v && typeof v === "object" ? v : fallback);

/** A week view with every list present, whatever the server left out. */
export function safeWeek(w: WeekView): WeekView {
  return {
    ...w,
    days: list(w.days), versions: list(w.versions), cells: list(w.cells), violations: list(w.violations), sessions: list(w.sessions),
    people: list(w.people).map((p) => ({ ...p, pattern: obj(p.pattern, {}), absences: list(p.absences) })),
    simulation: { ...obj(w.simulation, { days: [], devices: 0, feasible: true }), days: list(w.simulation?.days) },
    forecast: { week: w.forecast?.week ?? 0, days: obj(w.forecast?.days, {}) },
    shown: w.shown ?? null, lockedBefore: w.lockedBefore ?? null
  };
}

export function safeStats(s: StatsView): StatsView {
  return { ...s, devicesByDay: list(s.devicesByDay), attainment: list(s.attainment), rates: list(s.rates) };
}

export function safeBoard(b: BoardView): BoardView {
  return {
    ...b,
    week: safeWeek(obj(b.week, {} as WeekView)), shelves: list(b.shelves), slides: list(b.slides), now: b.now ?? null,
    stats: safeStats(obj(b.stats, {} as StatsView)),
    yesterday: b.yesterday ? { ...b.yesterday, sessions: list(b.yesterday.sessions) } : null
  };
}
